import { Types } from '../../../constants';
import { IsHelper } from '../IsHelper';
export class IsUndefinedHelper extends IsHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Undefined;
    }
}

//# sourceMappingURL=IsUndefinedHelper.js.map
